import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import cns from 'classnames';
import { noop, deburr, debounce } from 'lodash/fp';
import Autocomplete from 'react-autocomplete';
import FormControl from 'react-bootstrap/lib/FormControl';
import Highlighter from 'react-highlight-words';
import { connect } from 'react-redux';

import cn from './styles.local.less';
import * as actions from './actions';
import { toOptions } from './selectors';
import poweredByGoogleImg from './img/poweredByGoogle.png';

const AUTOCOMPLETE_FETCH_INTERVAL = 500;
const DEFAULT_ITEM = {};
const MINIMUM_QUERY_LENGTH = 3;

class Control extends PureComponent {
  static propTypes = {
    clearable: PropTypes.bool,
    input: PropTypes.object,
    onChanged: PropTypes.func,
    loadLocationForQuery: PropTypes.func.isRequired,
    loadPlaceDetails: PropTypes.func.isRequired,
    onReset: PropTypes.func,
    placeholder: PropTypes.string,
    initialValue: PropTypes.string,
    inputRef: PropTypes.func,
    qaSelector: PropTypes.string,
  };

  static defaultProps = {
    clearable: false,
    onChanged: noop,
    qaSelector: '',
  };

  constructor(...args) {
    super(...args);

    this.handleQueryChange = debounce(
      AUTOCOMPLETE_FETCH_INTERVAL,
      this.handleQueryChange,
    );
  }

  state = {
    suggestions: [],
    value: this.getValue(this.props),
  };

  componentDidMount() {
    if (this.props.inputRef) {
      this.props.inputRef(this.inputRef.refs.input);
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const currentValue = this.getValue(this.props);
    const nextValue = this.getValue(nextProps);

    if (currentValue !== nextValue) {
      this.setState({ value: nextValue });
    }
  }

  getInputProps() {
    const { onFocus } = this.props.input;

    return {
      onFocus,
    };
  }

  getWordsForHighlight() {
    const { value } = this.state;

    return value ? [value] : [];
  }

  getValue({ input: { value } }) {
    return value ? value.city : '';
  }

  handleInputChange = (e) => {
    const { value } = e.target;

    if (!value) {
      this.clearValue();
    } else {
      this.setState({ value });
      this.handleQueryChange(value);
    }
  };

  handleQueryChange = (query) => {
    if (query && query.length >= MINIMUM_QUERY_LENGTH) {
      const { loadLocationForQuery } = this.props;

      this.handleChange({
        city: query,
      });

      loadLocationForQuery(query)
        .then(({ result = [] }) =>
          this.setState({ suggestions: toOptions(result) }),
        )
        .catch(() => {
          return null;
        });
    }
  };

  handleChange = (item) => {
    const { input, onChanged } = this.props;

    input.onChange(item);

    onChanged(item);
  };

  clearValue = () => {
    this.setState({ value: '' });
    this.handleChange(DEFAULT_ITEM);
  };

  handleSelectItem = (value, item) => {
    const { loadPlaceDetails } = this.props;
    const {
      value: { placeId },
    } = item;

    loadPlaceDetails(placeId)
      .then(({ result }) => {
        this.setState({ value });
        this.handleChange({
          ...result,
          originCity: result.city,
          city: item.value.description,
        });
      })
      .catch(() => {
        return null;
      });
  };

  handleValueFiltering = (item, value) => {
    const valueToFilter = deburr(value.toLowerCase());
    const {
      value: { description },
    } = item;

    return deburr(description.toLowerCase()).indexOf(valueToFilter) !== -1;
  };

  renderInput = ({ ref, ...rest }) => {
    const { clearable, input, placeholder, qaSelector } = this.props;
    const { value } = this.state;
    const showClearable = clearable && !!value;

    return (
      <div className={cn.container}>
        <FormControl
          {...input}
          {...rest}
          className={cn.input}
          inputRef={ref}
          placeholder={placeholder}
          data-qa-selector={qaSelector}
        />
        {showClearable ? (
          <button className={cn.reset} onClick={this.clearValue}>
            ×
          </button>
        ) : null}
      </div>
    );
  };

  renderItem = (item, highlight) => {
    return (
      <div
        key={item.label}
        className={cns(cn.item, { [cn.active]: highlight })}
        data-qa-selector={highlight ? 'active' : null}
      >
        <Highlighter
          key={item.label}
          searchWords={this.getWordsForHighlight()}
          textToHighlight={item.label}
          highlightClassName={cn.highlightTerm}
        >
          {item.label}
        </Highlighter>
      </div>
    );
  };

  renderLabel({ label }) {
    return label;
  }

  renderMenu = (items) => {
    return (
      <div
        className={cns(cn.menu, { hidden: !items.length })}
        data-qa-selector="locationMenu"
      >
        {items}
        <div className={cn.googleContainer}>
          <img src={poweredByGoogleImg} alt="powered by google" />
        </div>
      </div>
    );
  };

  render() {
    const { suggestions, value } = this.state;

    return (
      <Autocomplete
        getItemValue={this.renderLabel}
        items={suggestions}
        inputProps={this.getInputProps()}
        shouldItemRender={this.handleValueFiltering}
        renderInput={this.renderInput}
        renderItem={this.renderItem}
        value={value}
        onChange={this.handleInputChange}
        onSelect={this.handleSelectItem}
        renderMenu={this.renderMenu}
        wrapperStyle={{ display: 'initial' }}
        ref={(el) => {
          this.inputRef = el;
        }}
      />
    );
  }
}

export default connect(null, actions)(Control);
